import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  CircularProgress,
  Dialog,
  Menu,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import SideBar from "../components/SideBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../assets/css/SideBar.css";

const schema = yup.object().shape({
  ToConsigneeName: yup.string().required("Consignee name is required"),
  ToAddress: yup.string().required("Address is required"),
  ToRef: yup.string().required("ToRef is required"),
  ToMobile: yup.string().required("Mobile is required"),
  ToPhone: yup.string().required("Phone is required"),
  ToContactPerson: yup.string().required("ContactPerson is required"),
  SpecialInstuctions: yup.string().required("Special Instructions is required"),
  ProductID: yup.number().required("Product is required"),
  ToCityID: yup.number().required("ToCityID is required"),
  CurrencyID: yup.number().required("CurrencyID is required"),
  PaymentMethodID: yup.number().required("Payment method is required"),
  COD: yup.number().required("COD is required"),
  Data8: yup.string().required("Nationality is required"),
});

export default function DataEntry() {
  const { t } = useTranslation();
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [clients, setClients] = useState([]);
  const [subAccounts, setSubAccounts] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [cities, setCities] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [Products, setProducts] = useState([]);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isCodLocked, setIsCodLocked] = useState(false);
  const [isCurrencyLocked, setIsCurrencyLocked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [awb, setAwb] = useState(null);
  const [nationalities, setNationalities] = useState([]);

  // فتح القائمة عند الضغط على زر الطباعة
  const handlePrintClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked); // تحديث الحالة عند تغيير التشيك بوكس
    console.log("Checkbox checked:", e.target.checked);
  };
  // إغلاق القائمة
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const fetchData = async () => {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const config = {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      };
      const body = {
        PageSize: 100,
        PageNumber: 0,
      };
      try {
        const clientsResponse = await axios.post(
          "https://tarabotcs.com-eg.net/api/Agent/V1/GetClientsList",
          body,
          config
        );
        setClients(clientsResponse.data.Data);
        // جلب العملات
        const currenciesResponse = await axios.get(
          "https://tarabotcs.com-eg.net/api/Agent/V1/GetCurrencies",
          config
        );
        setCurrencies(currenciesResponse.data.Data);

        // جلب المدن
        const citiesResponse = await axios.get(
          "https://tarabotcs.com-eg.net/api/Agent/V1/GetCities",
          config
        );
        setCities(citiesResponse.data.Data);

        // جلب طرق الدفع
        const paymentMethodsResponse = await axios.get(
          "https://tarabotcs.com-eg.net/api/Agent/V1/GetPaymentMethods",
          config
        );
        setPaymentMethods(paymentMethodsResponse.data.Data);

        // جلب المنتجات
        const productsResponse = await axios.get(
          "https://tarabotcs.com-eg.net/api/Agent/V1/GetProducts",
          config
        );
        setProducts(productsResponse.data.Data);

        const nationalitiesResponse = [
          "الإكوادور",
          "الإمارات العربية المتحدة",
          "الأرجنتين",
          "الأردن",
          "البحرين",
          "البرازيل",
          "البرتغال",
          "البوسنة والهرسك",
          "التبت",
          "التشيك",
          "الجبل الأسود",
          "الجزائر",
          "الدنمارك",
          "الرأس الأخضر",
          "السعودية",
          "السلفادور",
          "السنغال",
          "السودان",
          "السويد",
          "الصحراء الغربية",
          "الصومال",
          "الصين",
          "العراق",
          "الغابون",
          "الفاتيكان",
          "الفلبين",
          "الكويت",
          "المالديف",
          "المجر",
          "المغرب",
          "المكسيك",
          "المملكة المتحدة",
          "النرويج",
          "النمسا",
          "النيجر",
          "الهند",
          "الولايات المتحدة",
          "اليابان",
          "اليمن",
          "اليونان",
          "إثيوبيا",
          "إريتريا",
          "إسبانيا",
          "إستونيا",
          "إسرائيل",
          "إندونيسيا",
          "إيران",
          "إيطاليا",
          "أذربيجان",
          "أرمينيا",
          "أستراليا",
          "أفغانستان",
          "ألبانيا",
          "ألمانيا",
          "أنتيغوا وباربودا",
          "أنجولا",
          "أنجويلا",
          "أندورا",
          "أوروغواي",
          "أوزبكستان",
          "أوغندا",
          "أوكرانيا",
          "أيسلندا",
          "بابوا غينيا الجديدة",
          "باراغواي",
          "باربادوس",
          "باكستان",
          "بالاو",
          "باهاماس",
          "برمودا",
          "بروناي",
          "بلجيكا",
          "بلغاريا",
          "بنجلاديش",
          "بنما",
          "بنين",
          "بوتان",
          "بوتسوانا",
          "بورتوريكو",
          "بوركينا فاسو",
          "بورما ميانمار",
          "بوروندي",
          "بولندا",
          "بوليفيا",
          "بولينيزيا الفرنسية",
          "بيرو",
          "بيلاروس",
          "بيليز",
          "تايلاند",
          "تركمانستان",
          "تركيا",
          "ترينيداد وتوباغو",
          "تشاد",
          "تشيلي",
          "تنزانيا",
          "توغو",
          "توفالو",
          "تونس",
          "تونغا",
          "تيمور الشرقية",
          "جامايكا",
          "جرينلاند",
          "جزر العذراء الأمريكية",
          "جزر العذراء البريطانية",
          "جزر القمر",
          "جزر سليمان",
          "جزر فارو",
          "جزر فوكلاند",
          "جزر كايمان",
          "جزر كوك",
          "جزر مارشال",
          "جزر ماريانا الشمالية",
          "جمهورية الدومينيكان",
          "جمهورية الكونغو",
          "جمهورية الكونغو الديمقراطية",
          "جمهورية أفريقيا الوسطى",
          "جمهورية أيرلندا",
          "جنوب السودان",
          "جنوب أفريقيا",
          "جورجيا",
          "جيبوتي",
          "دولة فلسطين",
          "دومينيكا",
          "رواندا",
          "روسيا",
          "رومانيا",
          "ريونيون",
          "زامبيا",
          "زيمبابوي",
          "ساحل العاج",
          "ساموا",
          "ساموا-الأمريكي",
          "سان مارينو",
          "سانت فينسنت والغرينادين",
          "سانت كيتس ونيفيس",
          "سانت لوسيا",
          "ساو تومي وبرينسيب",
          "سريلانكا",
          "سلوفاكيا",
          "سلوفينيا",
          "سنغافورة",
          "سوازيلند (إسواتيني)",
          "سوريا",
          "سورينام",
          "سويسرا",
          "سيراليون",
          "سيشل",
          "صربيا",
          "طاجيكستان",
          "عُمان",
          "غامبيا",
          "غانا",
          "غرينادا",
          "غواتيمالا",
          "غوادلوب",
          "غوام",
          "غيانا",
          "غينيا",
          "غينيا الاستوائية",
          "غينيا الفرنسية",
          "غينيا بيساو",
          "فانواتو",
          "فرنسا",
          "فنزويلا",
          "فنلندا",
          "فيتنام",
          "فيجي",
          "قبرص",
          "قطر",
          "قيرغيزستان",
          "كازاخستان",
          "كاليدونيا الجديدة",
          "كاميرون",
          "كرواتيا",
          "كمبوديا",
          "كندا",
          "كوبا",
          "كوريا الجنوبية",
          "كوريا الشمالية",
          "كوستاريكا",
          "كولومبيا",
          "كيريباتي",
          "كينيا",
          "لاتفيا",
          "لاوس",
          "لبنان",
          "لوكسمبورغ",
          "ليبيا",
          "ليبيريا",
          "ليتوانيا",
          "ليختنشتاين",
          "ليسوتو",
          "مارتينيك",
          "ماكاو",
          "مالاوي",
          "مالطا",
          "مالي",
          "ماليزيا",
          "مايوت",
          "مدغشقر",
          "مصر",
          "مقدونيا الشمالية",
          "منغوليا",
          "موريتانيا",
          "موريشيوس",
          "موزمبيق",
          "مولدوفا",
          "موناكو",
          "مونتسرات",
          "ناورو",
          "نيبال",
          "نيجيريا",
          "نيكاراجوا",
          "نيوزيلندا",
          "هايتي",
          "هندوراس",
          "هولندا",
          "هونغ كونغ",
          "واليس وفوتونا",
          "ولايات ميكرونيسيا المتحدة",
        ];

        setNationalities(nationalitiesResponse);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          console.log("Session expired, logging out...");
          localStorage.removeItem("userData"); // مسح بيانات المستخدم
          navigate("/"); // إعادة التوجيه إلى الصفحة الرئيسية
        }
      }
    };

    fetchData();
  }, []);
  const handleClientChange = async (_, newValue) => {
    setSelectedClient(newValue);
    setValue("ID", newValue?.ID || ""); // تحديث القيمة داخل الفورم
    setSubAccounts([]); // تصفير الحسابات الفرعية عند تغيير العميل

    if (!newValue?.ID) return; // التأكد من وجود ClientID

    const userData = JSON.parse(localStorage.getItem("userData"));
    const config = {
      headers: {
        CompanyID: userData.Data.CompanyID,
        AccessToken: userData.Data.AccessToken,
      },
    };

    const body = { PageSize: 100, PageNumber: 1 }; // إرسال بيانات الطلب

    try {
      const response = await axios.post(
        `https://tarabotcs.com-eg.net/api/Agent/V1/GetSubAccountList/${newValue.ID}`,
        body,
        config
      );

      if (response.data && response.data.Data) {
        setSubAccounts(response.data.Data); // تحديث قائمة الحسابات الفرعية
      }
    } catch (error) {
      console.error("خطأ أثناء جلب الحسابات الفرعية:", error);
    }
  };

  const handleProductChange = async (productId) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const config = {
      headers: {
        CompanyID: userData.Data.CompanyID,
        AccessToken: userData.Data.AccessToken,
      },
    };

    try {
      const response = await axios.get(
        `https://tarabotcs.com-eg.net/api/Agent/V1/GetProductByID/${productId}`,
        config
      );

      const productData = response.data.Data;
      setValue("COD", productData.Price); // Set COD with product price
      setValue("CurrencyID", productData.CurrencyID); // Set currency
      setIsCodLocked(true); // Lock the COD field
      setIsCurrencyLocked(true); // Lock the currency field
    } catch (error) {
      console.error("Error fetching product by ID:", error);
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
        localStorage.removeItem("userData"); // Clear user data
        navigate("/"); // Redirect to the home page
      }
    }
  };

  const handleSave = async (data) => {
    setLoading(true);
    const userData = JSON.parse(localStorage.getItem("userData"));
    const config = {
      headers: {
        CompanyID: userData.Data.CompanyID,
        AccessToken: userData.Data.AccessToken,
      },
    };

    const ShipmentData = {
      ...data,
      AWB: "",
      ClientID: data.ID,
      SubAccountID: data.SubAccountID,
      Data1: "",
      Data2: "",
      Data3: "",
      Data4: "",
      Data5: "",
      Data6: "",
      Data7: "",
      Data8: data.Data8,
      Data9: "",
      Data10: "",
      Contents: "",
      FromCity: "",
      FromPhone: "",
      ToAddress2: "",
      FromAddress: "",
      FromContactPerson: "",
      Route: "",
      ExtraData: {
        DataEntryID: 0,
        Price: data.COD,
        CurrencyID: data.CurrencyID,
        PaymentMethodID: data.PaymentMethodID,
      },
    };

    try {
      const response = await axios.post(
        "https://tarabotcs.com-eg.net/api/Agent/V1/SaveShipment",
        ShipmentData,
        config
      );
      const awbNumber = response.data.Data[0].AWB;
      setAwb(awbNumber);
      console.log("Shipment saved successfully:", response);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error saving shipment:", error);
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
        localStorage.removeItem("userData"); // Clear user data
        navigate("/"); // Redirect to the home page
      }
    } finally {
      setLoading(false); // Ensure loading is set to false in any case
    }
  };
  const handlePrintOption = async (option) => {
    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem("userData"));
      const reportId = option === "A4" ? 2 : 1;
      const response = await axios.post(
        "https://tarabotcs.com-eg.net/api/Agent/V1/GetReportAWBs",
        {
          AWBs: awb,
          ReportID: reportId,
        },
        {
          headers: {
            CompanyID: userData.Data.CompanyID,
            AccessToken: userData.Data.AccessToken,
          },
          responseType: "blob", // هذا يضمن أن الاستجابة تأتي كملف blob
        }
      );

      console.log("Print API Response:", response);

      // تحويل الاستجابة إلى ملف PDF
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // إنشاء رابط لعرض الملف
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // فتح الملف في نافذة جديدة للطباعة
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.focus();
          // printWindow.print();
        };
        handleCloseModal();
        setLoading(false);
        if (isCheckboxChecked) {
          // استخدم setValue بدلاً من reset
          setValue("ToConsigneeName", "");
          setValue("ProductID", "");
          setValue("COD", "");
          setValue("CurrencyID", "");
          setValue("ToRef", "");
        } else {
          reset();
        }
      } else {
        console.error("Failed to open the print window.");
      }
    } catch (error) {
      console.error("Print API Error:", error);
      // معالجة الأخطاء
    }
    handleMenuClose(); // إغلاق القائمة بعد الاختيار
  };

  const handleResetForm = () => {
    if (isCheckboxChecked) {
      // استخدم setValue بدلاً من reset
      setValue("ToConsigneeName", "");
      setValue("ProductID", "");
      setValue("COD", "");
      setValue("CurrencyID", "");
      setValue("ToRef", "");
    } else {
      reset();
    }
    setIsCodLocked(false);
    setIsCurrencyLocked(false);
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // إغلاق المودال
  };

  return (
    <Box sx={{ display: "flex" }}>
      <SideBar
        open={isSideBarOpen}
        toggleOpen={() => setIsSideBarOpen(!isSideBarOpen)}
      />
      <Box
        sx={{
          height: "calc(100vh - 100px)",
          width: "95%",
          marginTop: "70px",
          marginLeft: isSideBarOpen ? "250px" : "5px",
          transition: "margin-left 0.3s",
          marginRight: "10px",
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
        >
          <Typography variant="h4" sx={{ marginRight: "20px" }}>
            {t("dataEntry")}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                name="fixData"
                color="primary"
                onChange={handleCheckboxChange}
              />
            }
            label={t("fixData")}
          />
        </Box>

        <form onSubmit={handleSubmit(handleSave)}>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="ID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Autocomplete
                  fullWidth
                  {...field}
                  options={clients}
                  getOptionLabel={(option) => option.EnglishName || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.ID === value || option.ID === field.value
                  }
                  onChange={(_, value) => {
                    field.onChange(value?.ID || ""); // تحديث القيمة في الفورم
                    handleClientChange(_, value); // استدعاء API الحسابات الفرعية
                  }}
                  value={clients.find((c) => c.ID === field.value) || null} // إبقاء العميل المختار
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="اختر العميل"
                      variant="outlined"
                      fullWidth
                      error={!!errors.ID}
                      helperText={errors.ID?.message}
                    />
                  )}
                />
              )}
            />

            <Controller
              name="SubAccountID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Autocomplete
                  fullWidth
                  {...field}
                  options={subAccounts}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : option.EnglishName || ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.ID === value || option.ID === field.value
                  }
                  onChange={(_, value) => field.onChange(value?.ID || "")} // ✅ تحديث الحساب الفرعي فقط
                  value={
                    subAccounts.find((sub) => sub.ID === field.value) || null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="الحساب الفرعي"
                      variant="outlined"
                      fullWidth
                      sx={{ marginBottom: "20px" }}
                      error={!!errors.SubAccountID}
                      helperText={errors.SubAccountID?.message}
                    />
                  )}
                />
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="ToConsigneeName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("consigneeName")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToConsigneeName}
                  helperText={errors.ToConsigneeName?.message}
                />
              )}
            />
            <Controller
              name="ToCityID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Autocomplete
                  fullWidth
                  {...field}
                  options={cities}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.CityNameE || ""
                  } // عرض اسم المدينة
                  isOptionEqualToValue={(option, value) =>
                    option.CityID === value || option.CityID === field.value
                  } // مقارنة القيم بشكل صحيح
                  onChange={(_, value) => field.onChange(value?.CityID || "")} // تحديث القيمة المختارة
                  value={
                    cities.find((city) => city.CityID === field.value) || null
                  } // تأكد من ربط القيمة المختارة
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("toCity")}
                      variant="outlined"
                      fullWidth
                      sx={{ marginBottom: "20px" }}
                      error={!!errors.ToCityID}
                      helperText={errors.ToCityID?.message}
                    />
                  )}
                />
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="ToAddress"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("address")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToAddress}
                  helperText={errors.ToAddress?.message}
                />
              )}
            />
            <Controller
              name="ToMobile"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("mobile")}
                  variant="outlined"
                  type="number"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToMobile}
                  helperText={errors.ToMobile?.message}
                />
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="ToPhone"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("phone1")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToPhone}
                  helperText={errors.ToPhone?.message}
                />
              )}
            />
            <Controller
              name="ProductID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label={t("product")}
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ProductID}
                  helperText={errors.ProductID?.message}
                  onChange={(e) => {
                    field.onChange(e);
                    handleProductChange(e.target.value);
                  }}
                >
                  {Products.map((option) => (
                    <MenuItem key={option.ProductID} value={option.ProductID}>
                      {option.EnglishName}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="COD"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("cod")}
                  disabled
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.COD}
                  helperText={errors.COD?.message}
                  InputProps={{
                    readOnly: isCodLocked, // Make the field read-only if locked
                  }}
                />
              )}
            />
            <Controller
              name="CurrencyID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label={t("currency")}
                  disabled
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.CurrencyID}
                  helperText={errors.CurrencyID?.message}
                  InputProps={{
                    readOnly: isCurrencyLocked, // Make the field read-only if locked
                  }}
                >
                  {currencies.map((option) => (
                    <MenuItem key={option.CurrencyID} value={option.CurrencyID}>
                      {option.EnglishName}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="PaymentMethodID"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  label={t("paymentMethod")}
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.PaymentMethodID}
                  helperText={errors.PaymentMethodID?.message}
                >
                  {paymentMethods.map((option) => (
                    <MenuItem
                      key={option.PaymentMethodID}
                      value={option.PaymentMethodID}
                    >
                      {option.EnglishName}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
            <Controller
              name="ToRef"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("toRef")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToRef}
                  helperText={errors.ToRef?.message}
                />
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="SpecialInstuctions"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("specialInstruction")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.SpecialInstuctions}
                  helperText={errors.SpecialInstuctions?.message}
                />
              )}
            />
          </Box>
          <Box sx={{ display: "flex", gap: "15px" }}>
            <Controller
              name="ToContactPerson"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t("customerName")}
                  variant="outlined"
                  fullWidth
                  sx={{ marginBottom: "20px" }}
                  error={!!errors.ToContactPerson}
                  helperText={errors.ToContactPerson?.message}
                />
              )}
            />
            <Controller
              name="Data8"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={nationalities}
                  fullWidth // التأكد من أن العنصر يستخدم كامل العرض
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Search Nationality"
                      variant="outlined"
                      fullWidth // استخدام العرض الكامل داخل TextField
                      error={!!errors.Data8}
                      helperText={errors.Data8?.message}
                      sx={{
                        marginBottom: "20px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px", // تحسين شكل الحواف
                        },
                      }}
                    />
                  )}
                  onChange={(_, value) => field.onChange(value)} // تحديث القيمة عند الاختيار
                />
              )}
            />
          </Box>

          {/* زر الحفظ */}
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: "#263150",
              color: "white",
              width: "100%",
              marginBottom: "20px",
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "حفظ"}
          </Button>
        </form>

        <Dialog open={isModalOpen} onClose={handleCloseModal}>
          <DialogTitle>{t("shipmentSavedSuccessfully")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("shipmentSavedSuccessfully")}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleResetForm}
              sx={{ backgroundColor: "#263150", color: "white" }}
            >
              {t("addShipment")}
            </Button>
            <Button
              onClick={handlePrintClick}
              sx={{ backgroundColor: "#263150", color: "white" }}
            >
              {t("print")}
            </Button>
            {/* القائمة */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <option onClick={() => handlePrintOption("A4")}>A4</option>
              <option onClick={() => handlePrintOption("Receipt")}>
                Receipt
              </option>
            </Menu>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
